export const mainPalette = [
  '000000',
  '343434',
  '494949',
  '616161',
  '747474',
  '868686',
  '9C9C9C',
  'B4B4B4',
  'E3E3E3',
  'FFFFFF',
  '7F1400',
  'E62601',
  'EE9301',
  'FDFF03',
  '6BFE02',
  '70FCFF',
  '5478EC',
  '2109FF',
  '8407FF',
  'E71CFF'
];

export const additionalPalette = [
  'DAB1A5',
  'EBC7C6',
  'F7E3C5',
  'FCF2C2',
  'D8E8CC',
  'CEDCCC',
  'C7D4FA',
  'CEDEF3',
  'D3CDE9',
  'E4CDD9',
  'C9775D',
  'D9928E',
  'EFC78D',
  'F9E386',
  'B5D29A',
  'A0BCC4',
  'A3BAF7',
  '9FBDE9',
  'AB9ED4',
  'C79EB7',
  'B4401B',
  'C9605A',
  'E8AC57',
  'F7D749',
  '93BD6A',
  '769AA8',
  '7193EF',
  '749DDC',
  '8171C1',
  'AF7398',
  '8D2300',
  'B11D00',
  'D38920',
  'E5BC02',
  '6D9F3A',
  '4B7584',
  '476BDA',
  '4B78C4',
  '5A45A3',
  '904770',
  '6E2207',
  '7F1500',
  '9E5801',
  'AE8801',
  '3E6B00',
  '244552',
  '2C48CD',
  '26488E',
  '2D186E',
  '5F1D40',
  '491500',
  '520C00',
  '643900',
  '6E5600',
  '2B4504',
  '182D37',
  '263B80',
  '1A2F5B',
  '1D1247',
  '3F1A23'
];

export const mainPaletteSticker = ['FAF8E5', 'DBF1D7', 'D8F4FF', 'FFCDD6'];

export const additionalPaletteSticker = [
  'FFFACD',
  'FFDAB9',
  '98FB98',
  'ADD8E6',
  'FFC0CB',
  'E6E6FA',
  'FFD700',
  'FFA500',
  '32CD32',
  '00BFFF',
  'FF6347',
  'DA70D6',
  'F0E68C',
  'F28500',
  '006400',
  '4169E1',
  'D22D1D',
  '9932CC'
];

export const leftToolbarPaletteSticker = [
  'F0E68C',
  'FFD700',
  'FFFACD',
  'F28500',
  'FFA500',
  'FFDAB9',
  '006400',
  '32CD32',
  '98FB98',
  '4169E1',
  '00BFFF',
  'ADD8E6',
  'D22D1D',
  'FF6347',
  'FFC0CB',
  '9932CC',
  'DA70D6',
  'E6E6FA'
];

export const stickerCSSClassMapper = {
  FAF8E5: 'yellow-paper',
  FFFDF1: 'yellow-paper-1',
  FFFCE9: 'yellow-paper-2',
  FFF9C7: 'yellow-paper-3',
  FFF2CC: 'yellow-paper-4',
  FFF596: 'yellow-paper-5',
  FFE28D: 'yellow-paper-6',
  FFD700: 'yellow-paper-gold',
  FFFACD: 'yellow-paper-lemon',
  F0E68C: 'yellow-paper-khaki',
  FFA500: 'orange-paper',
  FFDAB9: 'orange-paper-peach',
  F28500: 'orange-paper-tangerine',
  DBF1D7: 'green-paper',
  F3FFE9: 'green-paper-1',
  DEF9D0: 'green-paper-2',
  C6F2B3: 'green-paper-3',
  '32CD32': 'green-paper-lime',
  '98FB98': 'green-paper-pale',
  '006400': 'green-paper-dark',
  D8F4FF: 'blue-paper',
  F0FAFF: 'blue-paper-1',
  DAF1FF: 'blue-paper-2',
  BBE2FB: 'blue-paper-3',
  '00BFFF': 'blue-paper-sky',
  ADD8E6: 'blue-paper-light',
  '4169E1': 'blue-paper-royal',
  FFCDD6: 'red-paper',
  FFF3F5: 'red-paper-1',
  FFEAEE: 'red-paper-2',
  FED6E2: 'red-paper-3',
  FFC0CB: 'red-paper-pink',
  D22D1D: 'red-paper-brick',
  FF6347: 'red-paper-tomato',
  F2EFFF: 'purple-paper-1',
  D7D7FF: 'purple-paper-2',
  CFC3FF: 'purple-paper-3',
  DA70D6: 'purple-paper-orchid',
  E6E6FA: 'purple-paper-lavender',
  '9932CC': 'purple-paper-dark',
  F9F9F9: 'grey-paper-1',
  F3F3F3: 'grey-paper-2',
  E8E8E8: 'grey-paper-3'
};

export const stickerCSSColorMapper = {
  'default-paper': '#FAF8E5',
  'yellow-paper': '#FAF8E5',
  'yellow-paper-1': '#FFFDF1',
  'yellow-paper-2': '#FFFCE9',
  'yellow-paper-3': '#FFF9C7',
  'yellow-paper-4': '#FFF2CC',
  'yellow-paper-5': '#FFF596',
  'yellow-paper-6': '#FFE28D',
  'yellow-paper-gold': '#FFD700',
  'yellow-paper-lemon': '#FFFACD',
  'yellow-paper-khaki': '#F0E68C',
  'orange-paper': '#FFA500',
  'orange-paper-peach': '#FFDAB9',
  'orange-paper-tangerine': '#F28500',
  'green-paper': '#DBF1D7',
  'green-paper-1': '#F3FFE9',
  'green-paper-2': '#DEF9D0',
  'green-paper-3': '#C6F2B3',
  'green-paper-lime': '#32CD32',
  'green-paper-pale': '#98FB98',
  'green-paper-dark': '#006400',
  'blue-paper': '#D8F4FF',
  'blue-paper-1': '#F0FAFF',
  'blue-paper-2': '#DAF1FF',
  'blue-paper-3': '#BBE2FB',
  'blue-paper-sky': '#00BFFF',
  'blue-paper-light': '#ADD8E6',
  'blue-paper-royal': '#4169E1',
  'red-paper': '#FFCDD6',
  'red-paper-1': '#FFF3F5',
  'red-paper-2': '#FFEAEE',
  'red-paper-3': '#FED6E2',
  'red-paper-pink': '#FFC0CB',
  'red-paper-brick': '#D22D1D',
  'red-paper-tomato': '#FF6347',
  'purple-paper-1': '#F2EFFF',
  'purple-paper-2': '#D7D7FF',
  'purple-paper-3': '#CFC3FF',
  'purple-paper-orchid': '#DA70D6',
  'purple-paper-lavender': '#E6E6FA',
  'purple-paper-dark': '#9932CC',
  'grey-paper-1': '#F9F9F9',
  'grey-paper-2': '#F3F3F3',
  'grey-paper-3': '#E8E8E8'
};
